import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/shared/services';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-register-activation',
  templateUrl: './register-activation.component.html',
  styleUrls: ['./register-activation.component.scss'],
})
export class RegisterActivationComponent implements OnInit {
  private readonly notifier: NotifierService;
  key: string = '';
  tenant: string = '';
  public activated = false;
  merchant: string = '';

  constructor(
    notifierService: NotifierService,
    private readonly router: Router,
    private merchantService: MerchantService,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthenticationService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.key = params?.key;
    });

    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
    this.merchant = this.merchantService.getLoginMerchant(this.tenant);

    this.authService
      .activateUser(this.key)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          this.activated = true;
        },
        (error) => {
          this.activated = false;
          this.goToLogin();
        }
      );
  }

  goToLogin() {
    this.router.navigateByUrl(`${this.tenant}/login?m=${this.merchant}`);
  }
}
